export default __webpack_public_path__ + "static/media/Header-5.b72c07e8.jpg";